import { Grid } from "@mui/material";
import { endOfMonth, endOfYear, startOfMonth, startOfYear } from "date-fns";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { convertDateToUTC, intlFormatDateShort } from "src/utils/time-utils";
import { CustomDateRangePicker } from "./CustomDateRangePicker/CustomDateRangePicker";
import { Props, AbsencesPeriodOptionValue, AbsencesPeriodQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../../reusable-components/QuickFilter/QuickFilter";

export const AbsencesPeriodQuickfilter = <Q extends AbsencesPeriodQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.absences_period";

  const forceClose = useRef<boolean>(false);

  const today = new Date();

  const options: QuickFilterOption<AbsencesPeriodOptionValue>[] = [
    {
      name: t(`${tRP}.any_time_period`),
      value: { fromDate: null, toDate: null },
    },
    {
      name: t(`${tRP}.current_month`),
      value: {
        fromDate: convertDateToUTC(startOfMonth(new Date())),
        toDate: convertDateToUTC(endOfMonth(new Date())),
      },
    },
    {
      name: t(`${tRP}.current_year`),
      value: {
        fromDate: convertDateToUTC(startOfYear(new Date())),
        toDate: convertDateToUTC(endOfYear(new Date())),
      },
    },
  ];

  const computeCustomLabel = (): string => {
    const { absencesPeriod } = quickFilters;

    return absencesPeriod.fromDate && absencesPeriod.toDate
      ? `${intlFormatDateShort(absencesPeriod.fromDate)}-${intlFormatDateShort(absencesPeriod.toDate)}`
      : !!absencesPeriod.fromDate && !absencesPeriod.toDate
      ? `From: ${intlFormatDateShort(absencesPeriod.fromDate)}`
      : !!absencesPeriod.toDate && !absencesPeriod.fromDate
      ? `To: ${intlFormatDateShort(absencesPeriod.toDate)}`
      : "Not selected";
  };

  return (
    <Grid
      sx={{
        "& .MuiFormControl-root": {
          maxWidth: "280px",
        },
      }}
    >
      <QuickFilter
        options={options}
        quickFilters={quickFilters}
        quickFilter="absencesPeriod"
        handleChangeQuickFilter={handleChangeQuickFilters}
        shrinkedLabel={t(`${tRP}.shrinked_label`)}
        defaultLabel={`${computeCustomLabel()}`}
        customWidth={"200px"}
        forceClose={forceClose}
      >
        <CustomDateRangePicker
          period={quickFilters.absencesPeriod}
          handlePeriodChange={(period: AbsencesPeriodOptionValue) => {
            handleChangeQuickFilters("absencesPeriod", period);

            forceClose.current = true;
          }}
        />
      </QuickFilter>
    </Grid>
  );
};
